// IShareFundamentas type is not yet available from its original component location.
// Using a local placeholder until the type is migrated.
type IShareFundamentas = Record<string, unknown>;

import { API_PATHS } from "../constants/api-paths";

import { request } from "../core/api.client";

export const getScriptFundamentals = async (
  exchId: string,
  formattedSymbol: string
): Promise<IShareFundamentas> => {
  const response = await request<IShareFundamentas>({
    method: "GET",
    url: `${API_PATHS.stockFundaments}?exchId=${exchId}&formattedSymbol=${formattedSymbol}`,
  });
  return response.data;
};
